module.exports = new __parcel__URL__("marker-icon.6f236dca.png").toString();